export default () => {
    const list_li_container__opened_class = 'hh-dropdown-li--opened';
    const $dropdown_li = $('.js-hh-dropdown-li');

    $dropdown_li.each((index, element) => {
        $(document).click(event => {
            if (! $(element).is(event.target)
                && $(element).has(event.target).length === 0
            )
            {
                $(element).removeClass(list_li_container__opened_class);
            }
        })
    });

    $dropdown_li.find('.hh-dropdown-li__list-name').click(() => {
        $dropdown_li.toggleClass(list_li_container__opened_class);
    });
}